<template>
  <div v-if="visible">
      <div class="dim">
          <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
              <div class="modal-dialog" role="document">
                   <div class="modal-content" >
                       <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">중복확인</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()"><span aria-hidden="true">×</span></button>
                       </div>
                       <div class="modal-body">
                            <table class="table table-hover text-center">
                                <thead>
                                    <tr align="center" height="25">
                                        <th width="30" class="table02">노출시스템</th> 
                                        <th width="40" class="table02">교재 명</th> 
                                        <th width="30" class="table02">최근 업데이트 일</th> 
                                    </tr>
                                </thead>
                                <tbody v-if="ebookList.length > 0" >
                                    <tr v-for="(item,index) in ebookList" :key="'book'+index">
                                        <td >
                                            {{ item.ebookExposureSystem }}
                                        </td>
                                        <td class="cursor" @click="newOpen(`book/bookDetail/${item.ebookIdx}/${item.ebookVersion}`)">
                                            {{ item.ebookName }}
                                        </td>
                                        <td >
                                            {{ item.ebookUpdateDate | dateformat(item.ebookUpdateDate) }}
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr >
                                         <td colspan="99">
                                            검색 결과가 없습니다.
                                         </td>
                                    </tr>
                                </tbody>
                                    
                            </table>
                            <div v-if="ebookList.length > 0" style="padding-left:34%; padding-top:20px;">
                                <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                                        :click-handler="clickCallback" :prev-text="'Prev'"
                                        :next-text="'Next'" :container-class="'pagination'"
                                        :page-class="'page-link'">

                                </paginate>
                            </div>
                            
                       </div>
                   </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
export default {
    name: 'ebookModal',
    props:{
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        bookname:{
            type: String,
            require: true,
            default: ''
        },
    },
    watch: {
        visible: function (newVal) {
            if (newVal === true) {
                this.visible = true;
                this.pageNum = 1;
                this.lastpage = 1;
                this.getEbookList();

            } else {
                this.visible = false;
            }
        }
    },
    data() {
        return {
            ebookList:[],
            pageNum:1,
            lastpage: 1,//마지막 페이지
        }
    },
    methods: {
        close() {
            this.$emit("close", false);
        },
        /**
         * @description : 이북리스트 조회
         */
        getEbookList(){
            const params={
                ebookName: this.bookname,
                pageNum: this.pageNum,
                pageSize: 10
            };

            this.axios.get("/api/v1/ebook/list",{params: params})
                .then((res)=>{
                    const { err,  ebookSize, ebookList} = res.data;
                    if(err === 0){
                        this.ebookList = ebookList;
                        this.lastpage = Math.ceil(ebookSize/10);
                    }else{
                        this.ebookList = [];
                    }
                })
                .catch((err) => {
                    console.error(`/api/v1/ebook/list error : `, err)
                });
        },

        /**
         * @description : paging call back
         */
        clickCallback(page){
            this.pageNum = page;
            this.getEbookList();
        },

         /**
         * @description : 다른 페이지 이동
         */
        goOtherPage(path){
            this.$router.push(path);
        },

        /**
         * 
         * @param {*} path
         * @description : 새창 이동 
         */
        newOpen(path){
            window.open(`${document.location.origin}/${path}`,'_blank')
        }
    },
    components:{
        Paginate
    }
}
</script>
<style scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}

.pagination-area li {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: black;
    border: 1px solid #dee2e6;
}

.cursor{
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/components/popEbookList.vue